export const iconFontAwesomeShoppingGift = (
	<i className="fa-solid fa-gift"></i>
);
